<template>
  <Modal v-model="showModal" :scrollable="true" :mask-closable="false" :width="width" @on-cancel="closeModal">
    <p slot="header">
      <Icon type="md-create" />
      <span class="header-label">{{ title }}</span>
    </p>
    <div style="position: relative;">
      <Spin v-if="loadingStatus" fix />
      <Form ref="form" :label-width="90" :model="formFields" :rules="ruleValidate">
        <FormItem v-if="formFields.id" label="车辆编码:" prop="cipherNumber">
          <Input v-model="formFields.cipherNumber" placeholder="请输入车辆编码..." size="small" disabled />
        </FormItem>
        <FormItem label="绑定车库:" prop="parkingId">
          <Select
            v-model="formFields.parkingId"
            clearable
            filterable
            placeholder="请选择绑定车库..."
            size="small"
            :loading="searchLoading"
            @on-change="handleParkingChange"
          >
            <Option v-for="garage in garages" :key="garage.id" :value="garage.id" :label="garage.name" />
          </Select>
        </FormItem>
        <FormItem label="车辆标签:" prop="tag">
          <Select
            v-model="formFields.tag"
            clearable
            filterable
            placeholder="请选择车辆标签..."
            size="small"
          >
            <Option v-for="tag in vehicleTags" :key="tag.value" :value="tag.value" :label="tag.label" />
          </Select>
        </FormItem>
        <FormItem label="车辆类型:" prop="type">
          <Select
            v-model="formFields.type"
            clearable
            filterable
            placeholder="请选择车辆类型..."
            size="small"
          >
            <Option v-for="item in types" :key="item.id" :value="item.id" :label="item.name" />
          </Select>
        </FormItem>
        <FormItem label="车辆车主:" prop="ownerId">
          <Select
            ref="select"
            v-model="formFields.ownerId"
            clearable
            filterable
            placeholder="请选择车辆车主..."
            size="small"
            :remote-method="searchOwner"
            :loading="searchLoading"
          >
            <Option v-for="member in owner" :key="member.id" :value="member.id" :label="member.realName + ' (' + member.mobile + ')'">
              <span>{{ member.realName }}</span>
              <span style="float:right;color:#ccc;padding-right: 15px;">{{ member.mobile }}</span>
            </Option>
          </Select>
        </FormItem>
        <FormItem label="其他用户:" prop="bindingMembers">
          <Select
            v-model="formFields.bindingMembers"
            clearable
            filterable
            multiple
            placeholder="请选择其他用户..."
            :remote-method="searchBindUser"
            :loading="searchLoading"
            size="small"
          >
            <Option
              v-for="member in bindingMembers"
              :key="member.id"
              :value="member.id"
              :label="member.realName + ' (' + member.mobile + ')'"
              :disabled="formFields.ownerId && formFields.ownerId === member.id"
            >
              <span>{{ member.realName }}</span>
              <span style="float:right;color:#ccc;padding-right: 15px;">{{ member.mobile }}</span>
            </Option>
          </Select>
        </FormItem>
        <FormItem :label="formFields.status === 2 ? '报停日期:' : '有效期限:'" prop="expireTime">
          <DatePicker
            v-model="formFields.expireTime"
            type="date"
            format="yyyy-MM-dd"
            placeholder="请输入车辆有效期..."
            style="width: 100%"
            size="small"
            @on-change="onExpireTimeChange"
          />
        </FormItem>
        <FormItem v-if="formFields.status === 2" label="原有效期:" prop="suspendDate">
          <Input v-model="formFields.suspendDate" size="small" disabled />
        </FormItem>
        <FormItem label="车辆品牌:" prop="vendor">
          <Select
            v-model="formFields.vendor"
            clearable
            filterable
            placeholder="请选择车辆品牌..."
            size="small"
          >
            <Option v-for="item in vendorList" :key="item" :value="item" :label="item" />
          </Select>
        </FormItem>
        <FormItem label="购买时长:" prop="purchaseDuration">
          <Select
            v-model="formFields.purchaseDuration"
            clearable
            filterable
            placeholder="请选择车辆购买时长..."
            size="small"
          >
            <Option v-for="item in purchaseDurationList" :key="item" :value="item" :label="item" />
          </Select>
        </FormItem>
        <FormItem label="电池类型:" prop="batteryType">
          <Select
            v-model="formFields.batteryType"
            clearable
            filterable
            placeholder="请选择车辆电池类型..."
            size="small"
            @on-change="onVehicleBatteryTypeChange"
          >
            <Option v-for="item in batteryTypeList" :key="item" :value="item" :label="item" />
          </Select>
        </FormItem>
        <FormItem v-if="formFields.batteryType !== '其他' && formFields.batteryType !== ''" label="电池品牌:" prop="batteryVendor">
          <Select
            v-model="formFields.batteryVendor"
            clearable
            filterable
            placeholder="请选择车辆电池品牌..."
            size="small"
          >
            <Option v-for="item in currentBatteryVendors" :key="item" :value="item" :label="item" />
          </Select>
        </FormItem>
        <FormItem v-if="formFields.batteryVendor === '其他'" label="品牌备注:" prop="batteryVendorRemarks">
          <Input v-model="formFields.batteryVendorRemarks" placeholder="请输入车辆电池品牌备注..." size="small" />
        </FormItem>
        <FormItem label="电池使用时长:" prop="batteryDuration">
          <Select
            v-model="formFields.batteryDuration"
            clearable
            filterable
            placeholder="请选择车辆电池使用时长..."
            size="small"
          >
            <Option v-for="item in batteryDurationList" :key="item" :value="item" :label="item" />
          </Select>
        </FormItem>
        <FormItem label="车牌号:" prop="vehiclePlanetNumber">
          <Input v-model="formFields.vehiclePlanetNumber" placeholder="请输入车辆号码..." size="small" />
        </FormItem>
        <FormItem label="车辆备注:" prop="comments">
          <Input v-model="formFields.comments" placeholder="请输入车辆备注..." size="small" />
        </FormItem>
      </form>
      <div style="font-size: 12px; text-align: right; color: #69c">
        <Icon type="md-information-circle" /> 僵尸车辆，不需要提供车主信息！
      </div>
    </div>
    <div slot="footer">
      <Button
        type="primary"
        :disabled="loadingStatus"
        size="small"
        icon="ios-checkmark-circle-outline"
        :loading="submit"
        @click="saveOrUpdate"
      >
        保存
      </Button>
    </div>
  </Modal>
</template>

<script>
import request from '@/utils/request'
import { applyObject, formatDate } from '@/utils/util'
import { getConfigItem } from '@/apis'
export default {
  name: 'VehicleDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: ''
    },
    width: {
      type: Number,
      default: 500
    },
    action: {
      type: String,
      default: ''
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      intialized: false,
      loadingStatus: false,
      garageLoading: false,
      garages: [],
      types: [],
      vendorList: [],
      purchaseDurationList: [],
      currentBatteryVendors: [],
      batteryVendorList: [],
      batteryTypeList: [],
      batteryDurationList: [],
      searchLoading: false,
      memberLoading: false,
      members: [],
      bindingMembers: [],
      owner: [],
      modal: true,
      submit: false,
      mode: 0,
      formFields: {
        parkingId: '',
        planetNumber: '',
        cipherNumber: '',
        id: this.id,
        mode: 0,
        ownerId: '',
        tag: 0,
        bindingMembers: [],
        type: '',
        status: '',
        vendor: '',
        purchaseDuration: '',
        batteryVendor: '',
        batteryType: '',
        batteryVendorRemarks: '',
        vehiclePlanetNumber: '',
        batteryDuration: '',
        expireTime: '',
        comments: '',
        suspendDate: ''
      }
    }
  },
  computed: {
    vehicleTags() {
      return [
        { label: '普通车辆', value: 0 },
        { label: '僵尸车辆', value: 1 }
      ]
    },
    title() {
      if (this.caption) {
        return this.caption
      } else {
        return this.id ? '编辑车辆' : '添加新车辆'
      }
    },
    showModal: {
      get() { return this.visible },
      set(value) { }
    },
    isNormalVehicle() {
      return this.formFields.tag === 0
    },
    ruleValidate() {
      return {
        tag: [
          { required: true, message: '车辆标签不能为空!' }
        ],
        type: [
          { required: true, message: '车辆类型不能为空!' }
        ],
        parkingId: [
          { required: true, message: '绑定车库不能为空!' }
        ],
        ownerId: [
          { required: this.formFields.tag === 0, message: '车主不能为空!' }
        ],
        // expireTime: [
        //   { required: true, message: '车辆有效期不能为空!' }
        // ],
        planetNumber: [
          { required: true, message: '车辆编号不能为空!', trigger: 'blur' }
        ]
      }
    }
  },
  watch: {
    async showModal(val) {
      this.$refs.form.resetFields()
      this.types = []
      this.currentBatteryVendors = []
      this.loadingStatus = true
      this.intialized = false
      this.loadGarages()
      this.loadVehicleConfigs()
      // this.loadMembers()
      if (this.action && this.id) {
        request({
          url: this.action + '/' + this.id,
          method: 'get'
        }).then(res => {
          const data = res.data
          applyObject(data, this.formFields)

          // this.garages = [{ id: parkingId, name: parking }]
          this.loadVehicleTypes()

          this.formFields = { ...this.formFields, suspendDate: data.suspendDate, tag: data.tag || 0 }
          this.loadingStatus = false
          if (data.ownerId) {
            this.owner = [{ id: data.ownerId, realName: data.owner, mobile: data.mobile }]
          }

          if (this.formFields.batteryVendor) {
            const index = this.batteryTypeList.findIndex(item => item === this.formFields.batteryType)
            console.log(this.formFields.batteryVendor, index)
            if (index > -1) {
              this.currentBatteryVendors = this.batteryVendorList[index]
            }
          }

          const { bindingMembers, members, mobiles } = data
          if (bindingMembers) {
            this.bindingMembers = []
            for (var i = 0; i < bindingMembers.length; i++) {
              this.bindingMembers.push({ id: bindingMembers[i], realName: members[i], mobile: mobiles[i] })
            }
          }

          setTimeout(() => {
            this.intialized = true
          }, 900)
        }).catch(() => {
          // this.$Notice.error({
          //   title: '服务器数据请求失败',
          //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
          // })
          this.loadingStatus = false
          setTimeout(() => {
            this.intialized = true
          }, 500)
        })
      } else {
        this.loadGarages()
        this.loadVehicleTypes()
        this.intialized = true
        this.loadingStatus = false
      }
    }
  },
  methods: {
    searchBindUser(query) {
      // WA only
      this.searchUser(query, true)
    },
    searchOwner(query) {
      // WA only
      this.searchUser(query)
    },
    searchUser(query, isBindingUser = false) {
      const _this = this
      if (query !== '' && this.intialized) {
        _this.searchLoading = true
        request({
          url: this.$config.apiContextPath + '/member?pageSize=5&realName=' + query,
          method: 'get'
        }).then(res => {
          const data = res.data.content
          if (isBindingUser) {
            _this.bindingMembers = data
          } else {
            _this.owner = data
          }
          _this.searchLoading = false
        }).catch(error => {
          console.log(error)
          if (isBindingUser) {
            _this.bindingMembers = []
          } else {
            _this.owner = []
          }
          _this.searchLoading = false
        })
      }
    },
    searchParking(query) {
      if (query !== '' && this.intialized) {
        request({
          url: this.$config.apiContextPath + '/parking?name=' + query,
          method: 'get'
        }).then(res => {
          this.garages = res.data.content
        }).catch(error => {
          console.log(error)
          this.garages = []
        })
      }
    },
    async loadVehicleConfigs() {
      const _that = this
      await request({
        url: this.$config.apiContextPath + '/config?namespace=NS_VEHICLE',
        method: 'get'
      }).then(res => {
        const data = res.data.content
        if (data.length > 0) {
          this.vendorList = _that.getConfigValue(data, 'VEHICLE_VENDORS')
          this.batteryVendorList = _that.getConfigValue(data, 'VEHICLE_BATTERY_VENDOR')
          this.batteryDurationList = _that.getConfigValue(data, 'VEHICLE_BATTERY_DURATION')
          this.purchaseDurationList = _that.getConfigValue(data, 'VEHICLE_PURCHASE_DURATION')

          this.batteryTypeList = []
          this.batteryVendorList = []
          const batteryTypes = _that.getConfigValue(data, 'VEHICLE_BATTERY_TYPE')
          batteryTypes.forEach(item => {
            const option = this.convertToOptions(item)
            this.batteryTypeList.push(option.value)
            this.batteryVendorList.push(option.children)
            console.log(item, this.batteryTypeList)
          })
        }
      })
    },
    convertToOptions(text) {
      let key = text
      const hasChildren = text.indexOf('[') > -1 && text.indexOf(']') > -1
      let subOpts = []
      if (hasChildren) {
        const childText = text.substr(text.indexOf('[') + 1, text.indexOf(']') - text.indexOf('[') - 1)
        key = text.substr(0, text.indexOf('['))
        subOpts = childText.split('#')
      }
      return { value: key, children: hasChildren ? subOpts : [] }
    },
    getConfigValue(data, key) {
      const matched = data.find(item => item.key === key)
      if (matched) {
        return matched.value.split(',')
      } else {
        return []
      }
    },
    onVehicleBatteryTypeChange(e) {
      const index = this.batteryTypeList.findIndex(item => item === e)
      if (index > -1) {
        this.currentBatteryVendors = this.batteryVendorList[index]
      }
      this.formFields.batteryVendor = ''
      this.formFields.batteryVendorRemarks = ''
    },
    handleParkingChange(parkingId) {
      const query = parkingId ? '&parkingId=' + parkingId : ''
      request({
        url: this.$config.apiContextPath + '/vehicle/type?bypass=1&fetchAll=true' + query,
        method: 'get'
      }).then(res => {
        this.types = res.data.content
        // this.formFields.type = ''
      }).catch(error => {
        this.$Notice.error({
          title: '服务器数据请求失败',
          desc: '获取车库绑定车型失败'
        })
        console.log(error)
      })
    },
    async loadVehicleTypes() {
      if (this.formFields.parkingId) {
        const query = '&parkingId=' + this.formFields.parkingId
        await request({
          url: this.$config.apiContextPath + '/vehicle/type?fetchAll=true' + query,
          method: 'get'
        }).then(res => {
          this.types = res.data.content
        }).catch(error => {
          console.log(error)
          this.types = []
        })
      }
    },
    async loadGarages() {
      await request({
        url: this.$config.apiContextPath + '/parking/list',
        method: 'get'
      }).then(res => {
        this.garages = res.data
      }).catch(error => {
        console.log(error)
        this.garages = []
      })
    },
    async loadMembers() {
      const _this = this
      await request({
        url: this.$config.apiContextPath + '/member/list',
        method: 'get'
      }).then(res => {
        _this.members = res.data
      }).catch(error => {
        console.log(error)
        _this.members = []
      })
    },
    handlePlanetNumberModeChange: function(val) {
      this.mode = val
    },
    onExpireTimeChange: function(date) {
      this.formFields.expireTime = date
    },
    saveOrUpdate: function() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.action) {
            this.$refs.form.validate((valid) => {
              if (valid) {
                this.submit = true
                const isNew = this.formFields.id === 0
                if (this.formFields.expireTime) {
                  this.formFields.expireTime = formatDate(new Date(this.formFields.expireTime), 'yyyy-MM-dd hh:mm:ss')
                }
                request({
                  url: this.action + (isNew ? '' : ('/' + this.id)),
                  method: isNew ? 'POST' : 'PUT',
                  data: this.formFields
                }).then(res => {
                  this.loadingStatus = false
                  this.$Notice.success({
                    title: '数据保存成功',
                    desc: '车辆保存成功!'
                  })
                  this.submit = false
                  this.closeModal(true)
                }).catch(() => {
                  // this.$Notice.error({
                  //   title: '服务器数据请求失败',
                  //   desc: '请求地址: ' + this.action + ', 错误信息: ' + error
                  // })
                  this.loadingStatus = false
                  this.submit = false
                })
              }
            })
          }
        }
      })
    },
    closeModal: function(changed = false) {
      this.formFields = {
        status: 1,
        parkingId: '',
        planetNumber: '',
        expireTime: '',
        id: 0,
        type: '',
        ownerId: '',
        cipherNumber: ''
      }
      this.intialized = false
      this.garages = []
      this.members = []
      this.bindingMembers = []
      this.owner = []
      this.formFields.parkingId = ''
      this.formFields.bindingMembers = []
      this.$emit('on-close', changed)
    }
  }
}
</script>

